webpackJsonp([159071680842142],{

/***/ 489:
/***/ (function(module, exports) {

	module.exports = ["Anant Mishra","Ananya Bahadur","Arjun Singh","Ashish Singh","Gopal Shimpi","Jyoti Gautam","Jaypal Kadam","Pankaj Rawat","Raman Sah","Sagar Karwande","Vikram Jadon"]

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _Container = __webpack_require__(7);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Header = __webpack_require__(33);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _TitleAndMetaTags = __webpack_require__(17);
	
	var _TitleAndMetaTags2 = _interopRequireDefault(_TitleAndMetaTags);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _siteConstants = __webpack_require__(35);
	
	var _theme = __webpack_require__(4);
	
	var _acknowledgements = __webpack_require__(489);
	
	var _acknowledgements2 = _interopRequireDefault(_acknowledgements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Acknowlegements = function Acknowlegements(_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  return Glamor.createElement(
	    _Container2.default,
	    null,
	    Glamor.createElement(
	      'div',
	      { css: _theme.sharedStyles.articleLayout.container },
	      Glamor.createElement(
	        'div',
	        { css: _theme.sharedStyles.articleLayout.content },
	        Glamor.createElement(
	          _Header2.default,
	          null,
	          'Acknowledgements'
	        ),
	        Glamor.createElement(_TitleAndMetaTags2.default, {
	          ogUrl: _siteConstants.urlRoot + '/acknowledgements.html',
	          title: 'AviaCommerce - Acknowledgements'
	        }),
	        Glamor.createElement(
	          'div',
	          { css: _theme.sharedStyles.markdown },
	          Glamor.createElement(
	            'p',
	            null,
	            'We\'d like to thank all of our contributors:'
	          ),
	          Glamor.createElement(
	            'ul',
	            {
	              css: {
	                display: 'flex',
	                flexWrap: 'wrap'
	              } },
	            _acknowledgements2.default.map(function (name, index) {
	              return Glamor.createElement(
	                'li',
	                {
	                  css: {
	                    flex: '1 0 200px'
	                  },
	                  key: index },
	                name
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	}; /**
	    * Copyright (c) 2015-present, Aviabird
	    *
	    * @emails avia-core
	    */
	
	exports.default = Acknowlegements;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-acknowledgements-html-js-da8d6f7c3bdabb91f9c1.js